import moment from "moment";
import { SportMatchHotModel } from "models/promotionModel";
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { css } from "@emotion/css";
import bgSport from 'assets/images/sports/sport-banner.png';
import { menuList } from "interfaces/menuList";

interface Props {
    sportList: SportMatchHotModel[];
    onSelectGame: (game: any) => void;
}

function MatchFootball(props: Props) {
    const { sportList, onSelectGame } = props;

    const selectGame = () => {
        const ibcSport = menuList.find((item) => item.gametype === 'SB');
        const getbc = ibcSport?.child.find((item) => item.providercode === 'IBC2');
        if (getbc) onSelectGame(getbc);
    };

    return (
        <div className={styles.sportWrap}>
            <Swiper
                autoplay={{
                    delay: 10000,
                }}
                navigation={{
                    prevEl: '#swiper-prev-button',
                    nextEl: '#swiper-next-button',
                }}
                modules={[Autoplay, Navigation, Pagination]}
                pagination={{ clickable: true }}
                speed={600}
            >
                {sportList.map((item, index) => (
                    <SwiperSlide key={index}>
                        <div className="sport-item" onClick={() => selectGame()}>
                            <h4 className="sport-title">{item.description}</h4>

                            <div className="match-content">
                                <div className="club-item">
                                    <div className="club-info">
                                        <img className="club-flag" src={item.team1_photo} alt="" />
                                    </div>
                                    <p className="club-name">{item.team1_name}</p>
                                    <p className="rate-value">{item.team1_rate_bet}</p>
                                    <p className="rate-value full-time">FT.HDP {item.team1_rate_full}</p>
                                </div>
                                <div className="time-match">
                                    <div className="time-info">
                                        <h2>{moment(item.startdate).format('HH:mm')}</h2>
                                        <h4>{moment(item.startdate).format('DD/MM/yyyy')}</h4>
                                    </div>
                                </div>
                                <div className="club-item">
                                    <div className="club-info">
                                        <img className="club-flag" src={item.team2_photo} alt="" />
                                    </div>
                                    <p className="club-name">{item.team2_name}</p>
                                    <p className="rate-value">{item.team2_rate_bet}</p>
                                    <p className="rate-value full-time">FT.HDP {item.team2_rate_full}</p>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            <div className="button-prev4" id="swiper-prev-button">
                <img src={require(`assets/images/sports/next-icon.png`)} alt="" />
            </div>
            <div className="button-next4" id="swiper-next-button">
                <img src={require(`assets/images/sports/next-icon.png`)} alt="" />
            </div>
        </div>
    );
}

const styles = {
    sportWrap: css`
        background: url(${bgSport}) no-repeat center;
        background-size:  100% 100%;
        border-radius: 8px;
        position: relative;
        margin-right: 10px;
        padding: 10px 10px;
        cursor: pointer;
        .btn-navigate {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            z-index: 3;
            &:disabled {
                opacity: 0.3;
            }
            ion-icon {
                font-size: 28px;
                color: var(--ion-color-custom-white);
            }
            &.btn-next {
                right: 0;
            }
        }
        .sport-item {
            padding: 4px;
            display: flex;
            flex-direction: column;
            height: 100%;
            width: 100%;
            font-size: 16px;
            h2,
            h4 {
                margin: 0;
            }
            .sport-title {
                color: var(--ion-color-custom-white);
                border-radius: 16px 16px 0 0;
                text-align: center;
                padding-top: 4px;
            }
            .match-content {
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex: 1;
                margin-bottom: 6px;
                .time-match {
                    flex: 0 0 30%;
                    text-align: center;
                    h2,
                    h4 {
                        color: var(--ion-color-custom-white);
                    }
                    h2 {
                        font-size: 16px;
                    }
                    h4 {
                        font-size: 15px;
                    }
                    .time-info {
                        background: #000;
                        border-radius: 8px;
                        padding: 4px 8px;
                    }
                }
                .club-item {
                    flex: 0 0 35%;
                    max-width: 35%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    .club-info {
                        position: relative;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        img {
                            width: 60px;
                        }
                    }
                    .club-name {
                        text-align: center;
                        font-size: 13px;
                        color: var(--ion-color-custom-white);
                        font-weight: 500;
                        text-transform: uppercase;
                        overflow: hidden;
                        white-space: nowrap;
                        max-width: 110px;
                        margin: 0 auto;
                        text-overflow: ellipsis;
                    }
                    .rate-value {
                        color: var(--ion-color-custom-white);
                        text-align: center;
                        padding: 4px 8px;
                        width: fit-content;
                        margin: 0;
                        font-size: 14px;
                    }
                    .full-time {
                        border: 1px solid var(--ion-color-custom-white);
                        font-size: 14px;
                        background: rgba(0, 0, 0, 0.3);
                    }
                }
            }
        }
        .button-prev4,
        .button-next4 {
            position: absolute;
            top: 40%;
            z-index: 99;
            border-radius: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 40px;
            cursor: pointer;
            img {
                width: 18px;
            }
        }
        .button-prev4 {
            left: 30px;
            img {
                transform: rotate(180deg);
            }
        }
        .button-next4 {
            right: 30px;
            
        }
    `
};

export default MatchFootball;